<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          {{step?.name}}
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

      

        <ng-container *ngIf=" stepDetails?.can_edit">
          <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="commentForm?.invalid">
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- schemeType rev: Vendor name | RFP Received (Yes/No) | Meeting attended (Yes/No) -->
  <ng-container *ngIf="schemeType === 'rev'">
    <div class="prebid-rev-summary mb-4">
      <div *ngIf="stepDetails?.can_edit" class="d-flex justify-content-end mb-2">
        <button type="button" class="add-btn" (click)="addRevVendorRow()">+ Add Vendor</button>
      </div>
      <table class="custom-table table table-bordered prebid-rev-table">
        <thead>
          <tr>
            <th class="bg-primary text-white py-2 px-3">Vendor Name</th>
            <th class="bg-primary text-white py-2 px-3 text-center" style="width: 160px;">RFP Received</th>
            <th class="bg-primary text-white py-2 px-3 text-center" style="width: 180px;">Meeting Attended</th>
            <th *ngIf="stepDetails?.can_edit" class="bg-primary text-white py-2 px-3 text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of revVendorSummary; let i = index">
            <td class="align-middle">
              <input *ngIf="stepDetails?.can_edit" type="text" class="form-control form-control-sm" [(ngModel)]="v.vendor_name" [ngModelOptions]="{standalone: true}" placeholder="Vendor name" />
              <span *ngIf="!stepDetails?.can_edit">{{ v.vendor_name || '—' }}</span>
            </td>
            <td class="align-middle text-center">
              <ng-container *ngIf="stepDetails?.can_edit">
                <div class="d-flex justify-content-center gap-3 flex-wrap">
                  <label class="form-check-label small d-inline-flex align-items-center gap-1 me-2">
                    <input type="checkbox" [checked]="v.rfp_received" (change)="v.rfp_received = true" [id]="'rfp-yes-' + i" class="form-check-input" />
                    Yes
                  </label>
                  <label class="form-check-label small d-inline-flex align-items-center gap-1">
                    <input type="checkbox" [checked]="!v.rfp_received" (change)="v.rfp_received = false" [id]="'rfp-no-' + i" class="form-check-input" />
                    No
                  </label>
                </div>
              </ng-container>
              <span *ngIf="!stepDetails?.can_edit">{{ v.rfp_received ? 'Yes' : 'No' }}</span>
            </td>
            <td class="align-middle text-center">
              <ng-container *ngIf="stepDetails?.can_edit">
                <div class="d-flex justify-content-center gap-3 flex-wrap">
                  <label class="form-check-label small d-inline-flex align-items-center gap-1 me-2">
                    <input type="checkbox" [checked]="v.meeting_attended" (change)="v.meeting_attended = true" [id]="'mtg-yes-' + i" class="form-check-input" />
                    Yes
                  </label>
                  <label class="form-check-label small d-inline-flex align-items-center gap-1">
                    <input type="checkbox" [checked]="!v.meeting_attended" (change)="v.meeting_attended = false" [id]="'mtg-no-' + i" class="form-check-input" />
                    No
                  </label>
                </div>
              </ng-container>
              <span *ngIf="!stepDetails?.can_edit">{{ v.meeting_attended ? 'Yes' : 'No' }}</span>
            </td>
            <td *ngIf="stepDetails?.can_edit" class="align-middle text-center">
              <ng-container *ngIf="v.id == null">
                <button type="button" class="btn btn-sm btn-success" (click)="saveVendorAttendee(v)">Save</button>
              </ng-container>
              <ng-container *ngIf="v.id != null && !v.editMode">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="v.editMode = true">Edit</button>
              </ng-container>
              <ng-container *ngIf="v.id != null && v.editMode">
                <button type="button" class="btn btn-sm btn-success" (click)="saveVendorAttendee(v); v.editMode = false">Save</button>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="!revVendorSummary?.length">
            <td [attr.colspan]="stepDetails?.can_edit ? 4 : 3" class="text-center text-muted py-3">No vendors added</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <div class=" mt-3 mb-4">
    <div *ngIf="stepDetails.can_edit"  class="d-flex justify-content-end"><button class="add-btn" (click)="addRow()">+ Add Row</button></div>
    <table class="custom-table table ">
      <thead><tr>
        <!-- <th class="bg-primary text-white py-2 w-20">Serial No.</th>
        <th class="bg-primary text-white py-2">Query</th>
        <th class="bg-primary text-white py-2">Reply</th>
        <th class="bg-primary text-white py-2">Firm Name</th>
        <th class="bg-primary text-white py-2" *ngIf="stepDetails?.code == 'R-PBC'">Responded By</th>
        <th class="bg-primary text-white py-2" *ngIf="stepDetails?.code == 'R-PBC'">Action Taken By</th> -->
        <th class="bg-primary text-white py-2 w-20">Serial No.</th>
        <th class="bg-primary text-white py-2">{{stepDetails?.code == 'R-PBC' ? 'Firm Name/NHQ' : 'Firm Name'}}</th>
        <th class="bg-primary text-white py-2">{{stepDetails?.code == 'R-PBC' ? 'Query By Agenda Points' : 'Query'}}</th>
        <th class="bg-primary text-white py-2">{{stepDetails?.code == 'R-PBC' ? 'Reply By Discussion/Decision' : 'Reply'}}</th>
        <th class="bg-primary text-white py-2" *ngIf="stepDetails?.code == 'R-PBC'">Responded By</th>
        <th class="bg-primary text-white py-2" *ngIf="stepDetails?.code == 'R-PBC'">Action Taken By</th>
        <th *ngIf="stepDetails?.can_edit" class="bg-primary text-white py-2"  >Action</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let row of rows; let i = index">
          <td><ng-container *ngIf="row.edit; else s"><input type="text" class="form-control" [(ngModel)]="row.sequence"/></ng-container><ng-template #s>{{row.sequence || i+1}}</ng-template></td>
          <td><ng-container *ngIf="row.edit; else v"><input type="text" class="form-control" [(ngModel)]="row.vendor_name"/></ng-container><ng-template #v>{{row.vendor_name || row.applicant_name }}</ng-template></td>
          <td><ng-container *ngIf="row.edit; else q"><textarea class="form-control" rows="2" [(ngModel)]="row.query"></textarea></ng-container><ng-template #q>{{row.query}}</ng-template></td>
          <td><ng-container *ngIf="row.edit; else r"><textarea class="form-control" rows="2" [(ngModel)]="row.reply"></textarea></ng-container><ng-template #r>{{row.reply}}</ng-template></td>
          <td *ngIf="stepDetails?.code == 'R-PBC'"><ng-container *ngIf="row.edit; else respondedBy"><input type="text" class="form-control" [(ngModel)]="row.responded_by"/></ng-container><ng-template #respondedBy>{{row.responded_by}}</ng-template></td>
          <td *ngIf="stepDetails?.code == 'R-PBC'"><ng-container *ngIf="row.edit; else actionTakenBy"><input type="text" class="form-control" [(ngModel)]="row.action_taken_by"/></ng-container><ng-template #actionTakenBy>{{row.action_taken_by}}</ng-template></td>
          <td><ng-container *ngIf="stepDetails.can_edit">
            <button class="btn btn-sm btn-outline-primary me-1" *ngIf="!row.edit" (click)="row.edit=true">Edit</button>
            <button class="btn btn-sm btn-success" *ngIf="row.edit" (click)="saveRow(row); row.edit=false">Save</button>
          </ng-container></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mb-4">
    <app-upload-document [title]="stepDetails.name+'Document'" [isEditable]="stepDetails?.can_edit"> </app-upload-document>

    
  </div>
  <form [formGroup]="commentForm" class="proposal-form-container">
    <div class="form-container">
      <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
        <p class="p-2 bg-primary text-white ">{{stepDetails.name}} Justification</p>
        <editor [init]="init" formControlName="pre_bid" [disabled]="isEditorDisabled"></editor>
      </div>

    </div>
  </form>
</div>